/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

const PcModelSurveyBox = () => {
  const [isHovered, setIsHovered] = useState(false);
  const setHoverInState = () => {
    setIsHovered(true);
  };
  const setHoverOutState = () => {
    setIsHovered(false);
  };
  return (
    <>
      <div
        className="survey-box"
        onMouseOver={setHoverInState}
        onMouseOut={setHoverOutState}
      >
        <div>
          Want to see how this measures up against your own personal PC needs?
          Take the Find My PC quiz
        </div>
        <div className="">
          <Link legacyBehavior href="/survey">
            <a href="/survey">
              <Image draggable={false} 
                src={
                  isHovered
                    ? 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/dark-red-circle-arrow-right.svg?v=1713889907'
                    : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/red-circle-arrow-right.svg?v=1713889876'
                }
                alt="Survey"
                width={64}
                height={64}
              />
            </a>
          </Link>
        </div>
      </div>
      <style jsx>
        {`
          .survey-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 12px;
            max-width: 427px;
            margin: 16px 24px 16px 24px;
            padding: 8px 8px 8px 12px;
            font-family: 'Roboto-Medium';
            font-size: 13px;
            line-height: 20px;
            background-color: #000000;
            border-radius: 2px;
            cursor: pointer;
          }
          @media (max-width: 1024px) {
            .survey-box {
              width: 100%;
              margin: 0;
              margin-top: 0px;
              margin-bottom: 16px;
              max-width: unset;
            }
          }
        `}
      </style>
    </>
  );
};

export default PcModelSurveyBox;
